import { LocalStorageValues } from 'src/types/common';

export function setLocalStorageItem<Key extends keyof LocalStorageValues>(
  key: Key,
  value: LocalStorageValues[Key]
) {
  localStorage.setItem(key, JSON.stringify(value));
}

export function getLocalStorageItem<Key extends keyof LocalStorageValues>(
  key: Key
): LocalStorageValues[Key] | null {
  const item = localStorage.getItem(key);

  return item ? (JSON.parse(item) as LocalStorageValues[Key]) : null;
}

export function removeLocalStorageItem<Key extends keyof LocalStorageValues>(
  key: Key
) {
  localStorage.removeItem(key);
}

export function setLocalStorageItemWithExpiry<
  Key extends keyof LocalStorageValues,
>(key: Key, value: LocalStorageValues[Key], msDuration: number) {
  const now = Date.now();
  const item = {
    value,
    expiry: now + msDuration,
  };
  localStorage.setItem(key, JSON.stringify(item));
}

export function getLocalStorageItemWithExpiry<
  Key extends keyof LocalStorageValues,
>(key: Key): LocalStorageValues[Key] | null {
  const itemStr = localStorage.getItem(key);
  if (!itemStr) return null;

  try {
    const item = JSON.parse(itemStr) as {
      value: LocalStorageValues[Key];
      expiry: number;
    };
    if (Date.now() > item.expiry) {
      removeLocalStorageItem(key);
      return null;
    }
    return item.value;
  } catch {
    return null;
  }
}
